import {
  Card,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { colors } from 'design-system';
import React, { useState } from 'react';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

// models
import SalesTrend from 'src/models/Chart/SalesTrend';

// helpers
import { CustomLegend, createCustomTooltip, tickFormatter } from './helpers';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      gap: 30,
      flexWrap: 'nowrap',
      [theme.breakpoints.down('xs')]: {
        flexWrap: 'wrap',
      },
    },
    customXAxisLabel: {
      fontWeight: 400,
      fontSize: '10.7981px',
      lineHeight: '13px',
      letterSpacing: '0.599893px',
      color: '#808080',
    },
    title: {
      fontWeight: 900,
      fontSize: '19px',
      marginLeft: '28px',
      marginBottom: '15px',
    },
    titleSpan: {
      fontWeight: 600,
      fontSize: '15px',
      color: colors.abbey,
    },
    card: {
      borderRadius: 10,
      padding: 20,
      overflow: 'inherit',
      boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.08)',
    },
  }),
);

type LineGraphicProps = {
  salesTrend: SalesTrend[];
};

const LineGraphic = ({ salesTrend }: LineGraphicProps): React.ReactElement => {
  const classes = useStyle();
  const [selectedLine, setSelectedLine] = useState('');

  return (
    <Grid item xs={12} sm={12} md={10} className={classes.mainContainer}>
      <Card className={classes.card}>
        <Typography align="left" className={classes.title}>
          Tendencia de venta de pólizas auto{' '}
          <span className={classes.titleSpan}>(últimos 12 meses)</span>
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={salesTrend}>
            <XAxis
              dataKey="date"
              tick={{ fontSize: '10.7981px', color: '#808080' }}
              tickFormatter={tickFormatter}
            />
            <YAxis />
            <Tooltip
              allowEscapeViewBox={{ x: true, y: true }}
              wrapperStyle={{ top: -36, left: -7 }}
              content={createCustomTooltip(selectedLine)}
            />
            <CartesianGrid />
            <Legend
              verticalAlign="top"
              align="left"
              content={<CustomLegend />}
            />
            <Line
              key="vehicle"
              type="monotone"
              dataKey="vehicle"
              name="Cobertura Completa"
              stroke={colors.assa_blue}
              dot={false}
              strokeWidth={5}
              activeDot={{
                onMouseOver: () => setSelectedLine('vehicle'),
                onMouseLeave: () => setSelectedLine(''),
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Card>
    </Grid>
  );
};

export default LineGraphic;
